module.exports = __webpack_public_path__ + "img/08.9826ad49.jpg";